var $045970051df38095$exports = {};
$045970051df38095$exports = {
    "loading": `U\u{10D}itavam...`,
    "placeholder": `Odaberite\u{2026}`
};


export {$045970051df38095$exports as default};
//# sourceMappingURL=hr-HR.mjs.map
